import React, { useEffect } from "react";
import "./Services.scss";
import audit from "../../assets/images/services/audit.svg";
import design from "../../assets/images/services/design.svg";
import ecommerce from "../../assets/images/services/ecommerce.svg";
import responsive from "../../assets/images/services/responsive.svg";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

const list = [
  {
    image: responsive,
    variant: {
      hidden: {
        opacity: 0,
        translateX: -50,
      },
      show: {
        opacity: 1,
        translateX: 0,
        transition: {
          ease: [0.175, 0.885, 0.32, 1.275],
        },
      },
    },
    id: 1,
    title: "Responsive / Mobile-First",
    text: "Get a mobile-first website. Fully responsive for all screen sizes, from small screens, tablets, to desktops. ",
  },
  {
    image: audit,
    variant: {
      hidden: {
        opacity: 0,
        translateY: 50,
      },
      show: {
        opacity: 1,
        translateY: 0,
        transition: {
          ease: [0.175, 0.885, 0.32, 1.275],
        },
      },
    },
    id: 2,
    title: "Website  Audits",
    text: "Revamp a present website, fix bugs, or add a new feature to your site",
  },
  {
    image: design,
    variant: {
      hidden: {
        opacity: 0,
        translateY: -50,
      },
      show: {
        opacity: 1,
        translateY: 0,
        transition: {
          ease: [0.175, 0.885, 0.32, 1.275],
        },
      },
    },
    id: 3,
    title: "Design + Development",
    text: "From nothing to working, get your idea designed and developed.",
  },
  {
    image: ecommerce,
    variant: {
      hidden: {
        opacity: 0,
        translateX: 50,
      },
      show: {
        opacity: 1,
        translateX: 0,
        transition: {
          ease: [0.175, 0.885, 0.32, 1.275],
        },
      },
    },
    id: 4,
    title: "Personal Portfolio or SAAS product",
    text: "Reach out for getting assistant in building personal portfolio websites. Get  UI solutions for your SAAS product. ",
  },
];
const Services = () => {
  const { ref, inView } = useInView();
  const controls = useAnimation();
  const container = {
    hidden: {
      opacity: 0,
    },
    show: {
      opacity: 1,
      transition: {
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.4,
      },
    },
  };

  useEffect(() => {
    if (inView) controls.start("show");
  }, [controls, inView]);
  return (
    <motion.div
      className="servicesWrapper"
      animate={controls}
      ref={ref}
      variants={container}
      initial="hidden"
    >
      {list.map((item, id) => {
        return (
          <motion.div
            variants={item.variant}
            className="services"
            key={id}
            id={`service-${item.id}`}
          >
            <div className="tabs">
              <div className="tab" id="tab-1"></div>
              <div className="tab" id="tab-2"></div>
              <div className="tab" id="tab-3"></div>
            </div>
            <div className="">
              <div className="img">
                <img src={item.image} alt="preview" />
              </div>
              <div className="title">{item.title}</div>
              <div className="text">{item.text}</div>
            </div>
          </motion.div>
        );
      })}
    </motion.div>
  );
};

export default Services;
